import mobile from './mobile';
import cep from './cep';
import cnae from './cnae';
import cnpj from './cnpj';
import cpf from './cpf';
import date from './date';
import datetime from './datetime';
import decimal from './decimal';
import digits from './digits';
import document from './document';
import issn from './issn';
import landline from './landline';
import monthYear from './month-year';
import phone from './phone';
import shortPhone from './short-phone';
import time from './time';
import year from './year';

export default {
    mobile,
    cep,
    cnae,
    cnpj,
    cpf,
    date,
    datetime,
    decimal,
    digits,
    document,
    issn,
    landline,
    monthYear,
    'month-year': monthYear,
    phone,
    shortPhone,
    'short-phone': shortPhone,
    time,
    year,
};
